import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SubscripeSharedDataService {

  private isSubscribedBehvior: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false)
  isSubscribed: Observable<boolean> = this.isSubscribedBehvior.asObservable()

  private phoneNumberBehavior: BehaviorSubject<string> = new BehaviorSubject<string>("")
  phoneNumber: Observable<string> = this.phoneNumberBehavior.asObservable()

  private subscriptionNameBehavior: BehaviorSubject<string> = new BehaviorSubject<string>("")
  subscriptionName: Observable<string> = this.subscriptionNameBehavior.asObservable()

  private isLoginBehavior: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true)
  isLogin: Observable<boolean> = this.isLoginBehavior.asObservable()

  constructor() { }

  setIsSubscribed(isSubscribed: boolean) {
    this.isSubscribedBehvior.next(isSubscribed)
  }

  setPhoneNumber(phoneNumber: string) {
    this.phoneNumberBehavior.next(phoneNumber)
  }

  setSubscriptionName(subscriptionName: string) {
    this.subscriptionNameBehavior.next(subscriptionName)
  }

  setIsLogin(isLogin: boolean) {
    this.isLoginBehavior.next(isLogin)
  }

}
